import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const JoinOurTeam = ({image}) => {
  return (
    <div className="join-our-team overflow-x-hidden volto-section">
      <Container className="position-relative" >
        <Row>
          <Col lg={5}>
           <div className="join-now-header">
            <SectionHeader mainText1="JOIN" mainText2="OUR  TEAM"  />
            <SectionSubHeader headerText="Work with the best minds in the business." />
            <Link className="volto-know-more mt-lg-5 mt-3" to={"/contact"}>
              APPLY NOW
              <span>
                <BsArrowRight />
              </span>
            </Link>
            </div>
          </Col>
          <Col lg={7}> 
          <div className="join-now-image">
             <img className="join-now-user" src={image} alt="join-our-team" />
          </div>
          </Col>
        </Row>
        <img className="join-now-vector" src="/images/join-team-vector.svg" alt="join-team-vector" />
      </Container>
       
    </div>
  );
};

export default JoinOurTeam;
